export default "__VITE_ASSET__8NoF_bDW__"